import React from 'react';
import PropTypes from 'prop-types';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import shortid from 'shortid';

import './AlternatingImageTextGrid.scss';

const breakpoints = {
    mobile: {
        width: 375,
        height: 262,
    },
    tablet: {
        width: 500,
        height: 350,
    },
};

export default class AlternatingImageTextGrid extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                className: PropTypes.string,
                image: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }),
                content: PropTypes.shape({
                    label: PropTypes.string,
                    title: PropTypes.string,
                    description: PropTypes.string,
                }),
            })
        ).isRequired,
    };

    static defaultProps = {};

    loadRow = (item, row) => {
        const rowDirectionClass = row % 2 === 0 ? 'row-reverse' : 'row-forward';

        const customClassName =
            item.className && item.className.length ? item.className : '';
        const itemKey = shortid();

        return (
            <div key={itemKey} className={`single-row ${customClassName}`}>
                <div
                    className={`controlled-width-container ${rowDirectionClass}`}
                >
                    <div className="content-box">
                        <ResponsivePicture
                            cloudinaryID={item.image.src}
                            breakpoints={breakpoints}
                        />
                    </div>
                    <div className="content-box text-box">
                        <div className="text-controlled-container">
                            <FGBLabel className="black-font">
                                {item.content.label}
                            </FGBLabel>
                            <h3>{item.content.title}</h3>
                            <p>{item.content.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { items } = this.props;

        return (
            <div className="component-Layout-AlternatingImageTextGrid">
                {items.map((item, idx) => this.loadRow(item, idx + 1))}
            </div>
        );
    }
}
